import { render, staticRenderFns } from "./selectColumns.vue?vue&type=template&id=51515480&scoped=true"
import script from "./selectColumns.vue?vue&type=script&lang=js"
export * from "./selectColumns.vue?vue&type=script&lang=js"
import style0 from "./selectColumns.vue?vue&type=style&index=0&id=51515480&prod&scoped=true&lang=css"
import style1 from "./selectColumns.vue?vue&type=style&index=1&id=51515480&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51515480",
  null
  
)

export default component.exports